<template>
  <gkModal v-model="visible" class="modal-login">
    <div class="login-head">
      <h1 class="login-type">
        <span>企业登录</span>
        <span class="login-type-tip">管理员</span>
      </h1>

      <ul class="tag-list">
        <li v-if="(type === 1)">短信验证码登录</li>

        <template v-else>
          <li :class="{on: type === 3}" @click="setType(3)">邮箱密码登录</li>
          <li :class="{on: type === 2}" @click="setType(2)">手机号密码登录</li>
        </template>
      </ul>
      <!-- <p class="head-sub" v-if="type === 1">未注册的手机号或微信验证后将自动创建新账号，注册即代表同意<a target="_black" rel="noopener nofollow" href="//account.geekbang.org/agreement">《极客邦用户协议》</a></p> -->
      <!-- <p class="head-sub" v-if="type === 2">已有邮箱账户？<a href="http://" @click.prevent="bindEmail">点此绑定</a></p> -->
    </div>

    <div class="login-form">
      <LoginFormBiz
        :theme="theme"
        :type="type"
        @success="loginSuccess"
        @error="loginError"
        @hide="hide"
        @registerSuccess="$emit('registerSuccess')"
      />
    </div>

    <div class="footer" slot="footer">
      <div class="other-login-method">
        其他登录方式
        <img
          class="biz-wechat"
          src="https://static001.geekbang.org/resource/image/7b/be/7bf5b38df210e3dd6fcbfbc766727cbe.png"
          @click="routeWechart"
        />
      </div>
      <div class="toggle-login" @click="toggleLoginType">
        <template v-if="type === 1">
          账号密码登录
        </template>
        <template v-if="(type === 2 || type === 3)">
          手机验证码登录
        </template>
      </div>
    </div>
  </gkModal>
</template>

<script>
import state from '../../../store/state'
import VueTypes from 'vue-types'
import gkModal from 'gkuiV2/modal'

// import config from '../../../config'
// import utils from '../../../utils'

import LoginFormBiz from './LoginFormBiz'
// import sensorsReport from '../../../utils/sensors.report'
export default {
  name: 'modal-login',
  components: {
    gkModal,
    LoginFormBiz
  },
  props: {
    theme: VueTypes.oneOf(['blue', 'green']).def('blue')
  },
  data () {
    return {
      onSuccess: null,
      onError: null,
      visible: false,
      type: 3 // 登录类型  1 是手机验证码登录  2 是手机账号密码登录 3 邮箱账号密码登录
    }
  },
  computed: {
    loginTitle () {
      let domain = state.loginDomain === 'time' ? '极客时间' : ' InfoQ'
      return this.type === 1 ? `登录${domain}` : '密码登录'
    }
  },
  created () {
  },
  methods: {
    setType (type) {
      this.type = type
    },
    show ({success, error}) {
      this.visible = true
      this.onSuccess = success
      this.onError = error
      // sensorsReport.pushEvent('dialog_infoq_login', {
      //   login_type: '快捷登录'
      // })
    },
    hide () {
      this.visible = false
      this.onSuccess = null
      this.onError = null
    },
    loginSuccess () {
      this.onSuccess && this.onSuccess().then(() => {
        this.hide()
      }).catch((err) => {
        console.log(err)
      })
    },
    loginError () {
      this.onError && this.onError()
    },
    toggleLoginType () {
      this.type = this.type === 1 ? 3 : 1

      // sensorsReport.pushEvent('dialog_infoq_login', {
      //   login_type: this.type === 1 ? '快捷登录' : '密码登录'
      // })
    },
    // bindEmail () {
    //   window.open(`${config.account}/infoq/bind?redirect=${encodeURIComponent(location.href)}`)
    // },
    routeWechart () {
      const redirect = encodeURIComponent(window.location.href)

      window.location.href = `https://account.geekbang.org/account/oauth/authorizewxes?type=admin&redirect_url=${redirect}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_common";

.modal-login[gkmodal-color="base"] {
  & ::v-deep [gk-modal-main] {
    box-sizing: border-box;
    width: 442px; min-height: 504px;
    padding: 32px 49px 26px;

    @include mobile () {
      top: 0;
      width: 310px; min-height: auto;
      padding: 34px 24px 23px;
    }
  }
}

.login-head {
  height: 103px;
  margin: 25px 0 15px;

  @include mobile () {
    height: 83px;
    margin: 0;
  }
}

.login-type {
  display: flex; align-items: flex-end;
  line-height: 28px;
  @include font(28, 500);
  color: $lightBlack;

  .login-type-tip {
    margin-left: 16px;
    font-size: 13px;
    line-height: 16px;
    color: #8c8c8c;
  }

  @include mobile () {
    font-size: 20px;
  }
}

.tag-list {
  display: flex;
  padding-top: 50px;

  @include mobile {
    padding: 29px 2px 0;
  }

  & li {
    height: 25px;
    margin-right: 24px;
    @include lineFont(15);
    color: $gray;
    cursor: pointer;

    @include mobile {
      margin-right: 25px;
    }

    &.on {
      position: relative;
      font-weight: 500;
      color: $blue;

      &:after {
        content: '';
        display: block;
        position: absolute; left: 50%; bottom: 0;
        width: 50px; height: 2px;
        margin-left: -25px;
        background: $blue;
        border-radius: 2px;
      }
    }
  }
}

.head-sub {
  margin-top: 4px;
  line-height: 21px;
  @include font(14, 400);
  color: $gray;

  & a {
    color: $blue;
  }

  @include mobile () {
    // word-break: keep-all;
    margin-top: 3px; margin-right: -2px;
    line-height: 18px;
    font-size: 12px;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 20px;
  margin-top: 58px;
  @include font(14, 400);
  color: $gray;

  @include mobile () {
    font-size: 12px;
  }
}

.other-login-method {

  & .biz-wechat {
    width: 18px;
    margin-left: 5px;
    vertical-align: middle;
    cursor: pointer;

    @include mobile () {
      width: 16px;
    }
  }
}

.toggle-login {
  @extend %transition;
  cursor: pointer;
  user-select: none;

  @include web () {
    &:hover {
      color: $blue;
    }
  }
}
</style>
